import {
    getDisplayValue
} from '../format-display-value';

export function drawLocationHeader(detailsContainer, mapPoint) {
    const rndLat = getDisplayValue(mapPoint.latitude, '2dp');
    const rndLon = getDisplayValue(mapPoint.longitude, '2dp');

    const headerContainer = $(`<div></div>`);
    headerContainer.css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
        flexDirection: 'column'
    });

    // Display the coordinates container
    const locationTitle = $(`<h3>` + 
        `Location: ${rndLon}, ${rndLat}` + 
    `</h3>`);

    const buttonsContainer = $(`<div></div>`);
    buttonsContainer.css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        width: `100%`
    });

    // Create the downloads button
    const downloadBtn = $(`<button class="btn btn-link">` + 
        `Download` + 
    `</button>`);
    downloadBtn.css({
        fontSize: '12px'
    });
    buttonsContainer.append(
        downloadBtn
    );
    downloadBtn.on("click", function() {
        window.open('extract.html', '_blank');
    });

    // Create the 'Open in new tab' button
    const newTabBtn = $(`<button class="btn btn-link">` + 
        `Open in new tab` + 
    `</button>`);
    newTabBtn.css({
        fontSize: '12px'
    });
    buttonsContainer.append(
        newTabBtn
    );
    newTabBtn.on("click", function() {
        let baseUrl = 'chart.html'

        const lat = localStorage.getItem('fwfv_clicked_lat');
        const lon = localStorage.getItem('fwfv_clicked_lon');
        const currLayer = localStorage.getItem('fwfv_clicked_layer');

        let params = {
            layer: currLayer,
            lon: lon,
            lat: lat
        }

        let url = baseUrl + '?' + $.param(params);

        window.open(url, '_blank');
    })

    headerContainer.append(locationTitle);
    headerContainer.append(buttonsContainer);
        
    detailsContainer.append(headerContainer);   
}